<template>
  <div class="register">
    <!-- <div class="top-title">
      注册
    </div> -->
    <div class="content" :class="!isMobile ? 'pc-content' : '' ">
      <van-field
        label="服务商名称"
        ref="providerName"
        required
        autocomplete="off"
        maxlength="64"
        center
        placeholder="请输入"
        v-model.trim="providerAccountInfo.providerName"
        @click="domfocus($event,'providerName')"
      />
      <van-field
        label="注册手机号码"
        ref="mobile"
        required
        center
        placeholder="请输入"
        autocomplete="off"
        type="number"
        maxlength="11"
        inputmode="numeric"
        :disabled="againAudit==='1'"
        v-model.trim="accountForm.mobile"
        @input="(val)=>{
          providerAccountInfo.contactMobile=val
        }"
        @click="domfocus($event,'mobile')"
      />
      <template v-if="againAudit!=='1'">
        <van-field
          label="短信验证码"
          ref="smsVerifyCode"
          required
          autocomplete="off"
          center
          placeholder="请输入"
          inputmode="numeric"
          maxlength="6"
          v-model.trim="accountForm.smsVerifyCode"
          @click="domfocus($event,'smsVerifyCode')"
        >
          <template #button>
            <van-button 
              size="small" 
              type="info"
              native-type="button"
              :disabled=" timer > 0"
              @click="sendSmsVerifyCode($event)"
            >{{ +timer > 0 ? `${timer}s` : '获取验证码' }}</van-button>
          </template>
        </van-field>
        <van-field
          label="登录密码"
          ref="password"
          required
          center
          autocomplete="new-password"
          type="password"
          placeholder="请设置登录密码"
          v-model.trim="accountForm.password"
          @click="domfocus($event,'password')"
        />
        <van-field
          label="密码确认"
          ref="checkPassword"
          required
          center
          autocomplete="new-password"
          type="password"
          placeholder="请设置登录密码"
          v-model.trim="accountForm.checkPassword"
          @click="domfocus($event,'checkPassword')"
        />
      </template>
      <van-field
        label="服务商联系人"
        ref="contactName"
        autocomplete="off"
        required
        center
        maxlength="64"
        placeholder="请输入"
        v-model.trim="providerAccountInfo.contactName"
        @click="domfocus($event,'contactName')"
      />
      <van-field
        label="服务商联系电话"
        ref="contactMobile"
        autocomplete="off"
        required
        center
        maxlength="11"
        placeholder="请输入"
        v-model.trim="providerAccountInfo.contactMobile"
        @click="domfocus($event,'contactMobile')"
      />
      <van-field
        label="商户类型"
        ref="providerType"
        required
        autocomplete="off"
        center
        readonly
        placeholder="请输入"
        v-model.trim="providerAccountInfo.providerType"
        @click="showProviderTypePicker = true"
      />
      <!-- <van-field
        label="属性"
        ref="providerGradeAttribute"
        autocomplete="off"
        required
        center
        readonly
        placeholder="请输入"
        v-model.trim="providerAccountInfo.providerGradeAttribute"
        @click="showAttributePicker = true"
      /> -->
      <van-field
        label="企业全称"
        ref="providerFullName"
        autocomplete="off"
        required
        maxlength="64"
        center
        placeholder="请输入"
        v-model.trim="providerAccountInfo.providerFullName"
        @click="domfocus($event,'providerFullName')"
      />
      <van-field
        label="法人代表"
        ref="legalPerson"
        autocomplete="off"
        required
        center
        placeholder="请输入"
        maxlength="64"
        v-model.trim="providerAccountInfo.legalPerson"
        @click="domfocus($event,'legalPerson')"
      />
      <van-field
        label="统一信用编码"
        ref="unifiedCreditCode"
        autocomplete="off"
        required
        center
        placeholder="请输入"
        v-model="providerAccountInfo.unifiedCreditCode"
        @input="(e) => handleInput(e)"
        @click="domfocus($event,'unifiedCreditCode')"
      />
      <van-field
        maxlength="200"
        label="营业执照地址"
        ref="businessLicenseAddress"
        required
        autocomplete="off"
        center
        placeholder="请输入"
        v-model.trim="providerAccountInfo.businessLicenseAddress"
        @click="domfocus($event,'businessLicenseAddress')"
      />
      <van-field
        label="经营区域"
        ref="region"
        autocomplete="off"
        required
        center
        readonly
        placeholder="请输入"
        v-model.trim="providerAccountInfo.region"
        @click="showAreaPicker = true"
      />
      <van-field
        label="经营地详细地址"
        ref="providerBusinessAddress"
        required
        autocomplete="off"
        maxlength="200"
        center
        placeholder="请输入"
        v-model.trim="providerAccountInfo.providerBusinessAddress"
        @click="domfocus($event,'providerBusinessAddress')"
      />
      <van-field
        label="营业执照"
        ref="businessLicensePhoto"
        center
      >
        <template #input>
          <div class="upload-image">
            <div
              class="item" 
              v-for="(item,index) in providerAccountInfo.businessLicensePhoto"
              :key="item"
            >
              <van-image
                width="1.6rem"
                height="1.6rem"
                :src="item"
              />
              <div
                class="delete-icon"
                @click="deleteUploadImage(index,'businessLicensePhoto')"
              >
                <img src="@/assets/baibu/delete-icon.png" alt="">
              </div>
            </div>
            <van-uploader 
              v-model="businessLicensePhoto"
              :max-size="imgMaxSize"
              multiple
              accept="image/png, image/jpeg, image/jpg, image/pdf"
              v-if="providerAccountInfo.businessLicensePhoto.length<5"
              :before-read="(file)=>{
                return beforeUpload(file)
              }"
              :after-read="(file)=>{
                uploadImage(file,'businessLicensePhoto')
              }"
            />
          </div>
        </template>
      </van-field>
      <van-field
        label="经营地照片"
        ref="businessPhoto"
        center
      >
        <template #input>
          <div class="upload-image">
            <div
              class="item" 
              v-for="(item,index) in providerAccountInfo.businessPhoto"
              :key="item"
            >
              <van-image
                width="1.6rem"
                height="1.6rem"
                :src="item"
              />
              <div
                class="delete-icon"
                @click="deleteUploadImage(index,'businessPhoto')"
              >
                <img src="@/assets/baibu/delete-icon.png" alt="">
              </div>
            </div>
            <van-uploader 
              v-model="businessPhoto"
              :max-size="imgMaxSize"
              v-if="providerAccountInfo.businessPhoto.length<5"
              multiple
              accept="image/png, image/jpeg, image/jpg, image/pdf"
              :before-read="(file)=>{
                return beforeUpload(file)
              }"
              :after-read="(file)=>{
                uploadImage(file,'businessPhoto')
              }"
            />
          </div>
        </template>
      </van-field>
      <div class="checkbox">
        <van-checkbox 
          v-model="signContextCheck"
          disabled
          shape="square"
        ></van-checkbox>
        <div class="agreement">
          勾选同意
          <span @click="routerJump">
            《注册协议》
          </span>
        </div>
      </div>
      <div class="fix-operate">
        <van-button
          round
          block
          type="info"
          native-type="button"
          :class="!isMobile ? 'pc-fix-btn' : '' "
          @click="onSubmit"
        >{{this.againAudit==='1'?'重新提交':'立即注册'}}</van-button>
      </div>
      <van-popup v-model="showProviderTypePicker" position="bottom">
        <van-picker
          title="选择商户类型" 
          show-toolbar
          :columns="providerTypeList"
          @confirm="(value)=>{
            onConfirm(value,'providerType')
          }"
          @cancel="showProviderTypePicker = false"
        />

      </van-popup>
      <van-popup v-model="showAttributePicker" position="bottom">
        <van-picker
          title="选择属性" 
          show-toolbar
          :columns="providerGradeAttributeList"
          @confirm="(value)=>{
            onConfirm(value,'providerGradeAttribute')
          }"
          @cancel="showAttributePicker = false"
        />
      </van-popup>
      <van-popup v-model="showAreaPicker" position="bottom">
        <van-area 
          title="选择区域" 
          :area-list="areaList"
          @confirm="(value)=>{
            onConfirm(value,'region')
          }"
          @cancel="showAreaPicker = false"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { 
  getAccountDetail,
  getSmsVerifyCode,
  accountRegister,
  accountUpdate,
} from '@/api/baibu';

import { uploadFile } from '@/api/common';
import { areaList } from '@vant/area-data';

export default {
  name: 'ProviderRegister',
  data() {
    return {
      usingRouteBack: false,
      // 是否重新提交审核
      againAudit: '',
      // 显示商户类型
      showProviderTypePicker: false,
      // 显示属性
      showAttributePicker: false,
      // 显示省市区
      showAreaPicker: false,
      // 发送短信间隔
      verifyCodeTime: 60,
      // 倒计时
      timer: 0,
      // 图片大小
      imgMaxSize: 10 * 1024 * 1024,
      // 图片上传数量
      imgMaxCount: 5,
      // 省市区
      areaList,
      // 商户类型
      providerTypeList: [
        '个人', '个体工商户', '个人独资企业', '合伙企业', '有限责任公司', '其他',
      ],
      // 属性
      providerGradeAttributeList: [
        '专营代理', '兼营代理',
      ],
       
      // 账户表单
      accountForm: {
        mobile: '', // 注册手机号码
        smsVerifyCode: '', // 短信验证码
        password: '', // 登录密码
        checkPassword: '', // 密码确认
      },
      
      providerAccountInfo: {
        providerName: '', // 服务商名称
        contactName: '', // 服务商联系人
        contactMobile: '', // 服务商联系电话
        providerType: '', // 商户类型
        providerGradeAttribute: '', // 属性
        providerFullName: '', // 企业全称
        legalPerson: '', // 法人代表
        unifiedCreditCode: '', // 统一信用编码
        businessLicenseAddress: '', // 营业执照地址
        region: '', // 经营区域
        providerBusinessAddress: '', // 经营地详细地址
        businessLicensePhoto: [], // 营业执照
        businessPhoto: [], // 营业地照片
      },
      signContextCheck: true,
      // 营业执照
      businessLicensePhoto: [],
      // 营业地照片
      businessPhoto: [],
      // 类型
      sourceTypeName: 'provider',
      isMobile: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    document.title = '注册';
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'BaibuRegistrationAgreement') {
      next();
      return;
    }
    this.usingRouteBack = false;
    this.accountForm = {
      mobile: '', // 注册手机号码
      smsVerifyCode: '', // 短信验证码
      password: '', // 登录密码
      checkPassword: '', // 密码确认
    };
      
    this.providerAccountInfo = {
      providerName: '', // 服务商名称
      contactName: '', // 服务商联系人
      contactMobile: '', // 服务商联系电话
      providerType: '', // 商户类型
      providerGradeAttribute: '', // 属性
      providerFullName: '', // 企业全称
      legalPerson: '', // 法人代表
      unifiedCreditCode: '', // 统一信用编码
      businessLicenseAddress: '', // 营业执照地址
      region: '', // 经营区域
      providerBusinessAddress: '', // 经营地详细地址
      businessLicensePhoto: [], // 营业执照
      businessPhoto: [], // 营业地照片
    };

    next();
  },
  mounted() {
    this.getIsMobile();
  },
  methods: {
    getIsMobile() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      console.log(this.isMobile, 'isMobile');
    },
    handleInput(e) {
      this.providerAccountInfo.unifiedCreditCode = e.replace(/[^A-z\d]/g, '');
    },
    domfocus(e, ref) {
      e.stopPropagation();
      e.preventDefault();
      if (this.$refs[ref]) {
        this.$refs[ref].focus();
      }
    },
    // 账号表单验证
    accountValidateEvent(name = '') {
      const validate = {
        mobile: [
          { required: true, message: '手机号码不能为空' },
          { pattern: /^1\d{10}$/, message: '手机号码格式不正确' },
        ],
        smsVerifyCode: [
          { required: true, message: '短信验证码不能为空' },
          { pattern: /^\d{6}$/, message: '短信验证码格式不正确' },
        ],
        password: [
          { required: true, message: '请设置登录密码' },
          // { pattern: /^.{6,20}$/, message: '登录密码格式不正确' },
        ],
        checkPassword: [
          { validator: (val) => {
            return this.accountForm.password === val;
          },
          message: '两次输入的密码不一致' },
        ],
      };
      const errorMessage = this.getValidatorMessage(validate, this.accountForm, name) || '';
      return errorMessage;
    },

    formDataValidateEvent(name = '') {
      const validate = {
        providerName: [
          { required: true, message: '服务商名称不能为空' },
        ],
        contactName: [
          { required: true, message: '服务商联系人不能为空' },
        ],
        contactMobile: [
          { required: true, message: '服务商联系电话不能为空' },
          { pattern: /^1\d{10}$/, message: '服务商联系电话格式不正确' },
        ],
        providerType: [
          { required: true, message: '商户类型不能为空' },
        ],
        // providerGradeAttribute: [
        //   { required: true, message: '属性不能为空' },
        // ],
        providerFullName: [
          { required: true, message: '企业全称不能为空' },
        ],
        legalPerson: [
          { required: true, message: '法人代表不能为空' },
        ],
        unifiedCreditCode: [
          { required: true, message: '统一信用编码不能为空' },
          { pattern: /^[A-z\d]+$/g, message: '统一信用编码格式不正确' },
        ],
        businessLicenseAddress: [
          { required: true, message: '营业执照地址不能为空' },
        ],
        region: [
          { required: true, message: '经营区域不能为空' },
        ],
        providerBusinessAddress: [
          { required: true, message: '经营地详细地址不能为空' },
        ],
      };
      const errorMessage = this.getValidatorMessage(validate, this.providerAccountInfo, name);
      return errorMessage;
    },
    // 获取错误信息
    getValidatorMessage(validate, formData, name) {
      let errorMessage;
      const formList = Object.keys(formData);
      if (name) {
        errorMessage = this.validatorEvent(validate[name], formData[name]);
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < formList.length; i++) {
          const formKey = formList[i];
          const rules = validate[formKey];
          errorMessage = this.validatorEvent(rules, formData[formKey]);
          if (errorMessage) {
            break;
          }
        }
      }
      return errorMessage;
    },
    // 表单验证
    validatorEvent(rules = [], value) {
      let errorMessage = '';
      if (Array.isArray(rules) && rules.length) {
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < rules.length; j++) {
          if (rules[j].required && !value) {
            errorMessage = rules[j].message;
            break;
          }
          if (rules[j].pattern && !rules[j].pattern.test(value)) {
            errorMessage = rules[j].message;
            break;
          }
          if (rules[j].validator && !rules[j].validator(value)) {
            errorMessage = rules[j].message;
            break;
          }
        }
      }
      return errorMessage;
    },
    // 浮窗确认
    onConfirm(value, type) {
      if (type === 'region') {
        this.providerAccountInfo[type] = value
          .filter(item => !!item)
          .map(item => item.name)
          .join('/');
      } else {
        this.providerAccountInfo[type] = value;
      }
      this.showProviderTypePicker = false;
      this.showAttributePicker = false;
      this.showAreaPicker = false;
    },
    // 路由跳转
    routerJump() {
      this.usingRouteBack = true;
      this.$router.push({
        path: `/baibu/registration-agreement/${this.sourceTypeName}`,
        query: { usingRouteBack: 1 },
      });
    },
    // 获取短信验证码时间限制
    setTimer(seconds) {
      this.timer = seconds;
      const interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    // 上传图片
    async uploadImage(files, type) {
      // 上传单文件是对象 多文件是数组
      const form = new FormData();
      if (Array.isArray(files)) {
        const count = this.providerAccountInfo[type].length || 0;
        const canUploadIndex = this.imgMaxCount - count - 1;
        files.forEach((item, index) => {
          if (index <= canUploadIndex) {
            form.append('files', item.file);
          }
        });
      } else {
        form.append('files', files.file);
      }

      try {
        const { data = [] } = await uploadFile(form);

        const imageList = data.map((img) => {
          return img.url;
        });
        this.providerAccountInfo[type] = [
          ...this.providerAccountInfo[type],
          ...imageList,
        ];
      } catch (error) {
        console.error(error);
      }
    },
    // 图片超出大小
    beforeUpload(files) {
      console.log('files', files);

      let flag = true;
      if (Array.isArray(files)) {
        files.forEach((item) => {
          if (item.size >= this.imgMaxSize) {
            flag = false;
          }
        });
      } else if (files.size >= this.imgMaxSize) {
        flag = false;
      }
      if (!flag) {
        this.$toast('单个文件大小不能超过 10M');
      }
      return flag;
    },
    // 删除图片
    deleteUploadImage(index, type) {
      this.providerAccountInfo[type].splice(index, 1);
    },
    // 发送短信验证码
    async sendSmsVerifyCode(e) {
      e.stopPropagation();
      try {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在提交',
        });
        const message = this.accountValidateEvent('mobile');
        if (message) {
          this.$toast(message);
          return;
        }
        const { successful } = await getSmsVerifyCode(
          { phone: this.accountForm.mobile }, 
          { 'req-agent': `${this.sourceTypeName}-h5` },
        );
        this.$toast.clear();

        if (successful) {
          this.$toast('验证码发送成功');
          this.setTimer(this.verifyCodeTime);
        }
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    // 提交表单
    async onSubmit() {
      try {
        if (this.againAudit !== '1') {
          const accountErrorMessage = this.accountValidateEvent();
          if (accountErrorMessage) {
            this.$toast(accountErrorMessage);
            return;
          }
        }
        const formErrorMessage = this.formDataValidateEvent();
        if (formErrorMessage) {
          this.$toast(formErrorMessage);
          return;
        }
        if (!this.signContextCheck) {
          this.$toast('请同意并勾选《注册协议》');
          return;
        }
        const [
          providerBusinessProvince = '',
          providerBusinessCity = '',
          providerBusinessArea = '',
        ] = this.providerAccountInfo.region.split('/');
        let sendData = {
          businessType: this.sourceTypeName.toUpperCase(),
          signContext: window.localStorage.getItem(`${this.sourceTypeName}AccountInfo_signContext`) || '',
          providerAccountInfo: {
            ...this.providerAccountInfo,
            businessLicensePhoto: this.providerAccountInfo.businessLicensePhoto.join(',') || '',
            businessPhoto: this.providerAccountInfo.businessPhoto.join(',') || '',
            providerBusinessProvince,
            providerBusinessCity,
            providerBusinessArea,
          },
        };
        delete sendData.providerAccountInfo.region;

        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在提交',
        });
        if (this.againAudit === '1') {
          await accountUpdate(sendData, {
            'req-agent': `${this.sourceTypeName}-h5`,
            'current-user-id': Cookies.get(`${this.sourceTypeName}_userId`),
          });
          this.$toast('重新提交成功');
          setTimeout(() => {
            window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
            this.$toast.clear();
            this.$router.replace('/baibu/provider/login/success');
          }, 1500);
        } else {
          sendData = {
            ...sendData,
            ...this.accountForm,
          };

          await accountRegister(sendData, {
            'req-agent': `${this.sourceTypeName}-h5`,
          });
          this.$toast('提交成功');
          setTimeout(() => {
            window.localStorage.removeItem(`${this.sourceTypeName}AccountInfo_signContext`);
            Object.assign(this.$data, this.$options.data());
            this.$toast.clear();
            this.$router.replace({
              path: '/baibu/provider/login',
              query: {
                employeeName: sendData.mobile,
                password: sendData.password,
              },
            });
          }, 1500);
        }
      } catch (error) {
        this.$toast.clear();
        if (error.message === '会话过期，请重新登录') {
          Cookies.remove(`${this.sourceTypeName}_userId`);
          this.$router.replace('/baibu/provider/login');
        }
        console.log(error);
      }
    },
    getAccount() {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '正在获取',
      });
      getAccountDetail(
        {
          businessType: this.sourceTypeName.toUpperCase(),
        }, {
          'req-agent': `${this.sourceTypeName}-h5`,
          'current-user-id': Cookies.get(`${this.sourceTypeName}_userId`),
        },
      ).then((res) => {
        this.$toast.clear();

        const { mobile = '', providerAccountInfo = {} } = res.data;
        this.accountForm.mobile = mobile;
        Object.keys(this.providerAccountInfo).forEach((item) => {
          if (item === 'businessLicensePhoto') {
            if (providerAccountInfo.businessLicensePhoto.length > 0) {
              const imgList = providerAccountInfo.businessLicensePhoto.split(',');
              this.providerAccountInfo.businessLicensePhoto = imgList;
              this.businessLicensePhoto = imgList.map((url) => {
                return { url };
              });
            } else {
              this.providerAccountInfo.businessLicensePhoto = [];
            }
          } else if (item === 'businessPhoto') {
            if (providerAccountInfo.businessPhoto.length > 0) {
              const imgList = providerAccountInfo.businessPhoto.split(',');
              this.providerAccountInfo.businessPhoto = imgList;
              this.businessPhoto = imgList.map((url) => {
                return { url };
              });
            } else {
              this.providerAccountInfo.businessPhoto = [];
            }
          } else if (item === 'region') {
            if (providerAccountInfo.providerBusinessProvince) {
              const {
                providerBusinessProvince = '',
                providerBusinessCity = '',
                providerBusinessArea = '',
              } = providerAccountInfo;
              this.providerAccountInfo.region = `${providerBusinessProvince}/${providerBusinessCity}/${providerBusinessArea}`;
            } else {
              this.providerAccountInfo.region = '';
            }
          } else {
            this.providerAccountInfo[item] = providerAccountInfo[item];
          }
        });
        console.log(this.providerAccountInfo);
        this.$forceUpdate();
      }).catch((error) => {
        this.$toast.clear();
        if (error.message === '会话过期，请重新登录') {
          Cookies.remove(`${this.sourceTypeName}_userId`);
          this.$router.replace('/baibu/provider/login');
        }
      });
    },
  },
  activated() {
    this.$toast.setDefaultOptions({ duration: 1000 });
    if (Cookies.get(`${this.sourceTypeName}_userId`)) {
      if (`${this.$route?.query?.againAudit}` === '1') {
        this.againAudit = '1';
        if (this.usingRouteBack) {
          return;
        }
        this.getAccount();
      } else {
        this.$router.replace({
          path: '/baibu/provider/login/success',
        });
      }
    } else if (!window.localStorage.getItem(`${this.sourceTypeName}AccountInfo_signContext`)) {
      this.$router.replace({
        path: '/baibu/provider/login',
      });
    }  
  },
};
</script>

<style lang="scss" scoped>
.register {
  .top-title {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.32rem;
    font-weight: bold;
    text-align: center;
    border-bottom: 0.01rem solid rgb(228, 226, 226);
    background: #fff;
    z-index: 2;
    .goback-btn {
      position: absolute;
      left: 0.3rem;
      top: 50%;
      font-size: 0.2rem;
      transform: translateY(-50%);
      color: cornflowerblue;
    }
  }
  .content {
    padding: .2rem 0 2rem 0;
    .agreement {
      margin-left: 0.2rem;
      font-size: 0.32rem;
      span {
        color: #1989fa;
      }
    }
    ::v-deep {
      .van-cell:not(:last-child)::after{
        left: 0;
      }
      .van-field__control {
        line-height: 0.48rem;
      }
    }
    .checkbox {
      display: flex;
      align-items: center;
      padding: 0.2rem 0.3rem;
      ::v-deep {
        .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon{
          color: #fff;
        }
        .van-checkbox__icon--disabled .van-icon{
          background-color: #1989fa;
          border-color: #1989fa;
        }
      }
    }
    .upload-image {
      display: flex;
      flex-wrap: wrap;
      .item {
        position: relative;
        width: 1.6rem;
        height: 1.6rem;
        margin: 0 0.2rem 0.2rem 0;
        .delete-icon {
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 0.32rem;
          height: 0.32rem;
          background: rgba(0,0,0,0.3);
          img{
            width: 0.26rem;
            height: 0.26rem;
          }
        }
      }   
    }
    ::v-deep {
      .van-uploader__preview {
        display: none;
      }
    }
  }
  .fix-operate {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1.5rem;
    padding: 0 0.3rem;
    background: #fff;
  }
  .pc-content {
    width:200px;
    margin: 0 auto;
    ::v-deep {
      .van-field__label {
       font-size: 0.12rem;
        width: 2rem;
      }
      .van-cell--required::before {
       font-size: 0.12rem;
      }
      .van-button {
        font-size: 0.1rem;
        height: 0.24rem;
      }
      .van-field__body {
        font-size: 0.12rem;
      }
      .van-icon {
        font-size: 0.12rem;
      }
      .van-checkbox__icon--disabled {
        height: max-content;
      }
      .van-cell {
        padding: 0.01rem 0.32rem;
      }
    }
    .agreement {
      font-size: 0.12rem;
    }
    .fix-operate {
      position: relative;
      height: auto;
      padding: 0.1rem 0.3rem;
      .pc-fix-btn {
        font-weight: 500;
        width: max-content;
        height: 15px;
        line-height: 15px;
        font-size: 0.14rem;
      }
    }
  }
}
</style>
